import React from 'react';
import { DynamicDashboard } from '@/shared/components/dashboard';

export const SuperAdminDashboard: React.FC = () => {
  return (
    <DynamicDashboard
      title="Tableau de bord Super Admin"
      subtitle="Vue d'ensemble de la plateforme NEXEDU"
    />
  );
};
